export default {
    GET_RSEE_PACKAGES_LIST_LOADING: 'GET_RSEE_PACKAGES_LIST_LOADING',
    GET_RSEE_PACKAGES_LIST_SUCCESS: 'GET_RSEE_PACKAGES_LIST_SUCCESS',
    GET_RSEE_PACKAGES_LIST_FAILED: 'GET_RSEE_PACKAGES_LIST_FAILED',
    GET_RSEE_PACKAGES_LIST_REJECT: 'GET_RSEE_PACKAGES_LIST_REJECT',

    GET_USER_PACKAGES_LIST_LOADING: 'GET_USER_PACKAGES_LIST_LOADING',
    GET_USER_PACKAGES_LIST_SUCCESS: 'GET_USER_PACKAGES_LIST_SUCCESS',
    GET_USER_PACKAGES_LIST_FAILED: 'GET_USER_PACKAGES_LIST_FAILED',
    GET_USER_PACKAGES_LIST_REJECT: 'GET_USER_PACKAGES_LIST_REJECT',

    GET_USER_PACKAGE_TRANSACTIONS_LOADING: 'GET_USER_PACKAGE_TRANSACTIONS_LOADING',
    GET_USER_PACKAGE_TRANSACTIONS_SUCCESS: 'GET_USER_PACKAGE_TRANSACTIONS_SUCCESS',
    GET_USER_PACKAGE_TRANSACTIONS_FAILED: 'GET_USER_PACKAGE_TRANSACTIONS_FAILED',
    GET_USER_PACKAGE_TRANSACTIONS_REJECT: 'GET_USER_PACKAGE_TRANSACTIONS_REJECT',

    BUY_PACKAGE_LOADING: 'BUY_PACKAGE_LOADING',
    BUY_PACKAGE_SUCCESS: 'BUY_PACKAGE_SUCCESS',
    BUY_PACKAGE_FAILED: 'BUY_PACKAGE_FAILED',
    BUY_PACKAGE_REJECT: 'BUY_PACKAGE_REJECT',

    BUY_RSEE_LOADING: 'BUY_RSEE_LOADING',
    BUY_RSEE_SUCCESS: 'BUY_RSEE_SUCCESS',
    BUY_RSEE_FAILED:  'BUY_RSEE_FAILED',
    BUY_RSEE_REJECT:  'BUY_RSEE_REJECT',

};